import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Divider from '@mui/material/Divider';
import Typography from '@mui/material/Typography';

import useUser from '../../hooks/useUser';
import {setProviderId} from '../../redux/reducers/patientSignup';

const ExistingAccountDialog = props => {
  const { isOpen, onClose, provider, onIsNewAccount } = props;
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const redirectPath = `/clients/booking?providerId=${provider.id}`;
  const loginUrl = `/login?redirectPath=${redirectPath}`;
  const user = useUser();
  const loggedIn = user && user.id;
  useEffect(() => {
    if (loggedIn) navigate(loginUrl);
  }, [loggedIn]);
  return (
    <Dialog open={isOpen} onClose={onClose}>
      <DialogTitle>
        <Typography
          variant='h2'
          align='center'
        >
          Schedule a Session
        </Typography>
      </DialogTitle>
      <Divider />
      <DialogContent>
        <Typography variant='body'>
          Do you already have a MovementX account?
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={() => navigate(loginUrl)}>
          Yes
        </Button>
        <Button 
          onClick={() => {
            dispatch(setProviderId(provider.id));
            onIsNewAccount();
            onClose();
          }}
        >
          No
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ExistingAccountDialog;